












































import { ciFacebook } from '~/icons/source/solid/facebook'
import { ciInstagram } from '~/icons/source/solid/instagram'
import { SocialMediaLinks } from '~/models/dealer/types'
import { ciX } from '~/icons/source/brand/x'
import {
  defineComponent,
  defineVue3AsyncComponent,
  PropType,
  computed
} from '~/utils/nuxt3-migration'
import { ciYoutube } from '~/icons/source/solid/youtube'
import { Seller } from '~/models/classified/types'
import { ClassifiedMarketplaceInfo } from '~/models/classified/view'

export default defineComponent({
  components: {
    GoogleRating: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/google-rating/GoogleRating.vue'
      )
    ),
    MarketplaceSellerRating: defineVue3AsyncComponent(() =>
      import('~/components/car/marketplace/seller/MarketplaceSellerRating.vue')
    )
  },
  props: {
    socialMedia: {
      type: Object as PropType<SocialMediaLinks>,
      required: true
    },
    seller: {
      type: Object as PropType<Seller>,
      required: true
    },
    marketplace: {
      type: Object as PropType<ClassifiedMarketplaceInfo>,
      defalut: null
    }
  },

  setup(props) {
    const hasRating = computed(
      () =>
        (props.marketplace &&
          props.marketplace.product.seller.reviewDetails.count) ||
        props.seller.google_rating
    )
    return {
      ciFacebook,
      ciInstagram,
      ciYoutube,
      ciX,
      hasRating
    }
  }
})
